// Formatacao de nomes e documentos de contas (assinantes) para exibicao na interface

const LOWERCASE_WORDS = ['a', 'o', 'e', 'de', 'da', 'das', 'do', 'dos', 'em', 'na', 'nas', 'no', 'nos', 'para', 'por', 'com']
const UPPERCASE_WORDS = ['ltda', 'me', 'mei', 'epp', 'eireli', 'sa', 's/a', 's.a', 's.a.', 'cia', 'ii', 'iii', 'iv']
const VOWELS = /[aeiouáàâãéêíóôõúü]/i

function hasLowercase(text:string):boolean {
    return text !== text.toUpperCase()
}

function formatWord(word:string, isFirst:boolean):string {
    const lower = word.toLowerCase()

    // siglas: tem numero, esta na lista ou nao tem vogal (ex.: "C2B", "LTDA", "TV")
    if (/\d/.test(word) || UPPERCASE_WORDS.includes(lower) || !VOWELS.test(word)) {
        return word
    }

    if (!isFirst && LOWERCASE_WORDS.includes(lower)) {
        return lower
    }

    return lower.charAt(0).toUpperCase() + lower.slice(1)
}

// "CASA PUBLICADORA DAS ASSEMBLEIAS DE DEUS" -> "Casa Publicadora das Assembleias de Deus".
// So altera nomes escritos inteiramente em maiusculas; os demais sao respeitados como vieram
export function toDisplayName(name:string):string {
    const trimmed = (name || '').trim().replace(/\s+/g, ' ')

    if (!trimmed || hasLowercase(trimmed)) {
        return trimmed
    }

    return trimmed
        .split(' ')
        .map((word, index) => formatWord(word, index === 0))
        .join(' ')
}

// iniciais da primeira e da ultima palavra significativa (ignora "de", "da", ...)
export function getInitials(name:string):string {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean)
    const meaningful = parts.filter(part => !LOWERCASE_WORDS.includes(part.toLowerCase()))
    const words = meaningful.length ? meaningful : parts

    if (!words.length) {
        return ''
    }

    if (words.length === 1) {
        return words[0].substring(0, 2).toUpperCase()
    }

    return (words[0][0] + words[words.length - 1][0]).toUpperCase()
}

// CNPJ (14 digitos) e CPF (11 digitos) com mascara; qualquer outro valor volta como veio
export function formatDocument(document:string):string {
    const digits = (document || '').replace(/\D/g, '')

    if (digits.length === 14) {
        return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
    }

    if (digits.length === 11) {
        return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
    }

    return document || ''
}
